<style scoped>

</style>
<template>
  <ViewerItem
    v-if="expense_group.id"
    type="ExpenseGroup"
    :model_id="expense_group.id"
    class="link"
  >
    <slot :expense_group="expense_group">
      {{ expense_group.uid }}
    </slot>
  </ViewerItem>
  <span v-else>无</span>
</template>
<script>
  import ExpenseGroupUtil from '../libs/util';
  import ViewerItem from '../../components/viewer/item';

  export default {
    components: { ViewerItem },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        failed: false,
        expense_group: {}
      }
    },
    computed: {
      //
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        if (!this.id) return;
        if (this.loading) return;
        this.loading = true;
        this.failed = false;
        ExpenseGroupUtil.find(this.id)
          .then((data) => {
            this.expense_group = data.expense_group;
          }).catch((e) => {
            console.warn(e);
            this.failed = true;
          }).finally(() => {
            this.loading = false;
          })
      }
    }
  }
</script>
